/* eslint-disable react/destructuring-assignment */

/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';

import { faClock } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import InfoIcon from '../../assets/images/fixed-mock/info_black.svg';

import { formatDate } from '../../utils/helper';

import styles from '../../styles/timebase-testseries.module.scss';
import CountdownTimer from './CountDownTImer';

function TimeStatus(props) {
  const { item } = props;
  const starttime = item?.windowStartTime;
  const endtime = item.windowEndTime;
  const date = new Date();
  const currenttime = Date.parse(date);
  const startMinusCurrent = starttime - currenttime;
  const [endsInTimeSec, setEndsInTimeSec] = useState(0);
  const [startsInTimeSec, setStartsInTimeSec] = useState(0);
  const [timeStatusMod, setTimeStatusMod] = React.useState('');
  const [timeOverFlag, setTimeOverFlag] = useState(false);
  useEffect(() => {
    const startMinusCurrentInMin = Math.floor(startMinusCurrent / 1000 / 60);
    if (startMinusCurrentInMin <= 60 && startMinusCurrentInMin > 0) {
      setTimeStatusMod('START_NOW_COUNTER');
      setStartsInTimeSec((starttime - currenttime) / 1000);
    } else if (endtime - currenttime > 0) {
      if (startMinusCurrentInMin > 60) {
        setTimeStatusMod('OTHER');
      } else {
        setTimeStatusMod('ENDS_IN_COUNTER');
        setEndsInTimeSec((endtime - currenttime) / 1000);
      }
    } else {
      setTimeStatusMod('OTHER');
    }
  }, []);

  useEffect(() => {
    if (timeOverFlag) {
      props.getDataFlag(timeOverFlag);
    }
  }, [timeOverFlag]);

  const setTimeOverFlagFun = (data) => {
    if (data) {
      setTimeOverFlag(true);
    } else {
      setTimeOverFlag(false);
    }
  };
  if (timeStatusMod === 'START_NOW_COUNTER') {
    return (
      <div className={styles.timesings}>
        <div className={styles.alignCenter}>
          <FontAwesomeIcon icon={faClock} />
        </div>
        <span className={`${styles.startwith} ${styles.alignCenter} `}>
          Starts in{' '}
          <CountdownTimer
            expiresIn={startsInTimeSec}
            setTimeOverFlagFun={(data) => {
              setTimeOverFlagFun(data);
              setTimeStatusMod('ENDS_IN_COUNTER');
              setEndsInTimeSec((endtime - currenttime) / 1000);
            }}
            name="startsIn"
          />
        </span>
      </div>
    );
  }
  if (timeStatusMod === 'ENDS_IN_COUNTER') {
    return (
      <div className={styles.timesings}>
        <div className={styles.alignCenter}>
          <FontAwesomeIcon icon={faClock} />
        </div>
        <span className={`${styles.startwith} ${styles.alignCenter} `}>
          Ends in{' '}
          <CountdownTimer
            expiresIn={endsInTimeSec}
            setTimeOverFlagFun={(data) => {
              setTimeOverFlagFun(data);
              setTimeStatusMod('ENDS_IN_TIME_OVER');
            }}
            name="endsIn"
          />
        </span>
      </div>
    );
  }
  if (item?.userTestStatus === 'START_NOW') {
    if (item?.live === false && currenttime >= endtime) {
      return (
        <div className={styles.timesings}>
          <div className={styles.alignCenter}>
            <FontAwesomeIcon icon={faClock} />
          </div>
          <span className={`${styles.startwith} ${styles.alignCenter} `}>
            {`Ended on ${formatDate(item?.windowEndTime, 'ddd MMM')} ${formatDate(item?.windowEndTime, 'hh:mm aaa')}`}
          </span>
          <div className={styles.alignCenter}>
            <div className={styles.tooltip}>
              <InfoIcon />
              <span className={styles.tooltiptext}>Attempting test now will not be considered for global rank.</span>
            </div>
          </div>
        </div>
      );
    }
  }
  if (item?.userTestStatus === 'COMPLETED') {
    return (
      <div className={styles.timesings}>
        <span className={styles.startwith}>
          {`Attempted on  ${formatDate(item?.attemptedOn, 'ddd MMM')} ${formatDate(item?.attemptedOn, 'hh:mm aaa')}`}
        </span>
      </div>
    );
  }
  if (
    item?.userTestStatus === 'REGISTERED' ||
    item?.userTestStatus === 'REGISTER' ||
    item?.userTestStatus === 'Registration time is over now'
  ) {
    return (
      <div>
        <div className={styles.timesings}>
          <div className={styles.alignCenter}>
            <FontAwesomeIcon icon={faClock} />
          </div>
          <span className={`${styles.startwith} ${styles.alignCenter}`}>
            {item?.windowStartTime && formatDate((item.windowStartTime), 'ddd MMM')}
            {', '}
            {item?.windowStartTime && formatDate((item.windowStartTime), 'hh:mm aaa')}
            {' - '}
            {item?.windowEndTime && formatDate((item.windowEndTime), 'ddd MMM')}
            {', '}
            {item?.windowEndTime && formatDate((item.windowEndTime), 'hh:mm aaa')}
          </span>
        </div>
      </div>
    );
  }
  return (
    <span className={styles.startwith}>
      {item?.windowStartTime && formatDate((item.windowStartTime), 'ddd MMM')}
      {', '}
      {item?.windowStartTime && formatDate((item.windowStartTime), 'hh:mm aaa')}
      {' - '}
      {item?.windowEndTime && formatDate((item.windowEndTime), 'ddd MMM')}
      {', '}
      {item?.windowEndTime && formatDate((item.windowEndTime), 'hh:mm aaa')}
    </span>
  );
}

export default TimeStatus;
